import {  useRef } from "react";
import {
  ButtonContainer,
  ButtonSecondary,
  Container,
  LoginCard,
  LoginInput,
} from "../../screens/login.screen/login.styled";
import finger from "../../assets/fingerprint.svg";
import { ButtonPrimary } from "@components";
import User from "../../stores/UserStore";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Error from "../../components/error";
import ErrorSubscription from "../../stores/ErrorSubscriptionStore";
import { Spinner } from "../../components/SpinnerRaw/SpinnerRaw";
import CONSTANTS from "../../utils/constants";
import generalStore from "../../stores/GeneralStore";
import { callRemoteMethod } from "src/utils/WebserviceHandler";
import axios from "axios";
import General from "../../stores/GeneralStore";
import { observer } from "mobx-react";
import ReCAPTCHA from "react-google-recaptcha";
import { NotifyError } from "../../utils/ShowError";
import CloseIcon from "../../assets/CloseIcon.svg";
import { BaseProps } from "src/components/move-inRegistrationTabs/interfaces";
import { encrypt } from "../../utils/crypt";
import { toJS } from "mobx";
interface Obj {
  [key: string]: any;
}
interface Props extends BaseProps {
  owner: boolean;
  userValidatedDetails: Obj;
  premise: Obj;
  onClose:any;
}
const LoginModal = ({premise,owner,userValidatedDetails,onClose}:Props) => {
  const loginErrorId = "loginError";
  const [error, setError] = useState<any>({ username: "", password: "" });
  const [data, setData] = useState<any>({});
  const [isLoading, setIsLoading] = useState(false);
  const passwordRef=useRef<HTMLInputElement | null>(null);
  const userNmaeRef=useRef<HTMLInputElement | null>(null);
  const navigate = useNavigate();
  const [loginAttempts, setLoginAttempts] = useState(0); // Track login attempts
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false); // Track reCAPTCHA status
  //let user = new User();
  const MAX_LOGIN_ATTEMPTS = 3; // Set the maximum number of login attempts
  const key: string = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "";


  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;

 

  const getNotificationCount = async () => {
    await generalStore.getNotificationsCount({
      errorId: "getNotificationsCountError",
    });
  };

  const handleSubmit = async () => {
    // if(loginAttempts>=MAX_LOGIN_ATTEMPTS){
    //   setIsCaptchaVerified(false);
    // }
    // if (loginAttempts >= MAX_LOGIN_ATTEMPTS && !isCaptchaVerified) {
    //   setError("Please verify the reCAPTCHA.");
    //   NotifyError("Please verify the reCAPTCHA.")
    //   return;
    // }
    const password=passwordRef?.current?.value
    const username=userNmaeRef?.current?.value
    const data = {
      userName: encrypt(username as any) ,
      password:encrypt(password as any) ,
      uuid :   User.uaePassDetails.uuid ? User.uaePassDetails.uuid : null,
      emiratesId : User.uaePassDetails.emiratesId
      ? User.uaePassDetails.emiratesId
      : null,
      provider : 'UAEPASS',
      personId: owner?premise?.ownerAccount? premise?.ownerAccount.personID: userValidatedDetails?.personId: premise?.tenantAccount? premise?.tenantAccount.personID:userValidatedDetails?.personId,
      registrationStatus:General?.registrationStatus?.registationStatus
    };
    if (!username) {
      setError({ username: "email is required" });
    } else if (!password) {
      setError({ password: "password is required" });
    } else {
      setIsLoading(true);
      await User.uaePassLoginNOEID({
        data,
        errorId: loginErrorId,
      });
      setIsLoading(false);

      if (User.info.personId) {
        setLoginAttempts(0);
        User.getProfile(User.info.personId as string);
        localStorage.removeItem('redirectFrom')
        User.getFavourites();
        getNotificationCount();
        const redirectPath =
          localStorage.getItem("redirectPath") || "/dashboard";

        localStorage.removeItem("redirectPath");
        navigate(redirectPath);
      } else {
        setLoginAttempts((prevAttempts) => prevAttempts + 1);
      }
    }
  };


  const handleChange = (e: any) => {
    let value = e.target.value;
    setData({ ...data, [e.target.name]: value });
    setError({ username: "", password: "" });
  };

  useEffect(() => {
    // General?.handleBackClick()
    ErrorSubscription.unSubscribeAll();

    if (User.info.personId) {
      console.log("already logged in");
      User.getFavourites();
      navigate("/dashboard");
    }

    const handleKeyPress = (e:any) => {
      if (e.key === "Enter") {
        e.preventDefault();
        handleSubmit();
      }
    };

    document.addEventListener("keypress", handleKeyPress);

    // Remove the event listener when the component unmounts
    return () => {
      document.removeEventListener("keypress", handleKeyPress);
    };
  }, []);

  return (
    <div
    style={{
      width:General?.isLargeScreen? "60%":"100%",
      display: "flex",
      flexDirection: "column",
      backgroundColor: "#fff",
      margin: "auto",
    }}
  >
     <div
      style={{
        // height: '20%',
        width: "100%",
        justifyContent: "space-between",
        paddingLeft: "1rem",
        paddingRight: "1rem",
        background: "#101e8e",
        display: "flex",
        alignItems: "center",
      }}
      className={General?.colorClass}
    >
      <h1 style={{ color: contrast?.contrastColor ? contrast?.contrastColor :"#fff", justifySelf: "flex-start",fontSize:General?.isLargeScreen?"":"2rem" }}>
      {General?.codeLabels["cm_login"]?.label !== undefined ? General?.codeLabels["cm_login"]?.label : "Login"}
      </h1>
      <img src={CloseIcon} alt="" onClick={onClose} />
    </div>
    <LoginCard
        style={{
          backgroundColor: contrast?.contrastBackground
            ? contrast?.contrastBackground
            : "",
          color: contrast?.contrastColor ? contrast?.contrastColor : "#101e8e",
          padding: General?.isLargeScreen?"40px 40px 35px":"",
        }}
      >

        <p className={General?.textClass} style={{ fontSize: `${1.5* General.accessibility.fontSize}rem` }}>
          {General?.codeLabels["cm_uaepass_login_noeid"]
            ?.label !== undefined
            ? General?.codeLabels[
                "cm_uaepass_login_noeid"
              ]?.label
            : "Please enter your credentials to validate your account .This an one time activity only"}
        </p>
        <Error id={loginErrorId} />

        <label>
          <b style={{ fontSize: `${0.8 * General.accessibility.fontSize}rem` }}>
            {General?.codeLabels["cm_username"]?.label !== undefined
              ? General?.codeLabels["cm_username"]?.label
              : "Username"}{" "}
            *
            
          </b>
        </label>
        <LoginInput ref={userNmaeRef} name="username" onBlur={handleChange} />
        {error?.username && (
          <p style={{ color: "red" }}>Username is Required</p>
        )}
       <div></div>
        <label className={General?.textClass} style={{marginTop:'1rem'}}>
          <b style={{ fontSize: `${0.8 * General.accessibility.fontSize}rem` }}>
            {General?.codeLabels["cm_password"]?.label !== undefined
              ? General?.codeLabels["cm_password"]?.label
              : "Password"}
          </b>
        </label>
        <LoginInput ref={passwordRef} type="password" name="password" onBlur={handleChange} />
        {error?.password && (
          <p style={{ color: "red" }}>Password is Required</p>
        )}
       
          
        <ButtonContainer>
          {isLoading ? (
            <Spinner />
          ) : (
            <ButtonPrimary
              label={General?.codeLabels["cm_login"]?.label?General?.codeLabels["cm_login"]?.label:"Login"}
              styles={{
                height: "3rem",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                textAlign: "center",
                fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                zIndex: 0,
                marginTop:'1.5rem',
                background:General?.ColorAss?General?.ColorAss:''
              }}
              
              onClick={handleSubmit}
            />
          )}
        </ButtonContainer>
      </LoginCard>
  </div>
  );
};

export default observer(LoginModal);
